import React from 'react';
import AppRouter from './router/app-router';
// import { QueryClient, QueryClientProvider } from 'react-query';
// import { ReactQueryDevtools } from 'react-query/devtools';

const App = () => {
  // const queryClient = new QueryClient();
  return (
    // <QueryClientProvider client={queryClient}>
    //   <ReactQueryDevtools initialIsOpen={true} />
    <AppRouter />
    // </QueryClientProvider>
  );
};
export default App;
